/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingpublishcross2Inputs */

const en_crosspostingpublishcross2 = /** @type {(inputs: Crosspostingpublishcross2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish everywhere`)
};

const de_crosspostingpublishcross2 = /** @type {(inputs: Crosspostingpublishcross2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überall veröffentlichen`)
};

/**
* | output |
* | --- |
* | "Publish everywhere" |
*
* @param {Crosspostingpublishcross2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingpublishcross2 = /** @type {((inputs?: Crosspostingpublishcross2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingpublishcross2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingpublishcross2(inputs)
	return de_crosspostingpublishcross2(inputs)
});
export { crosspostingpublishcross2 as "crosspostingPublishCross" }